import _ from 'lodash';

const ASC_DESC_MAPPING = {
  true: 'asc', // eslint-disable-line quote-props
  false: 'desc', // eslint-disable-line quote-props
};

const defaultFilterHandler = (item, filters, key) => {
  const filterValue = _.toString(_.get(filters, key)).toLowerCase();
  const itemValue = _.toString(_.get(item, key)).toLowerCase();
  return !filterValue || itemValue.indexOf(filterValue) > -1;
};

function applyGrid(deps, fetchFunction, gridId, params = {}) {
  return _.flow([
    obj => _.set(obj, 'fetchData', fetchData.bind(null, fetchFunction, gridId)),
    obj => _.set(obj, 'applyFilters', applyFilters.bind(null, deps, gridId)),
    obj => _.set(obj, 'sortByColumn', sortByColumn.bind(null, deps, gridId)),
    obj => _.set(obj, 'changePageSize', changePageSize.bind(null, deps, gridId)),
    obj => _.set(obj, 'gotoPage', gotoPage.bind(null, deps, gridId)),
    obj => _.set(obj, 'nextPage', nextPage.bind(null, obj.gotoPage, deps, gridId)),
    obj => _.set(obj, 'prevPage', prevPage.bind(null, obj.gotoPage, deps, gridId)),
    obj => _.merge(obj, initialGridModel(deps, params))
  ])({});
}

function initialGridModel(deps, params) {
  return {
    loaded: false,
    data: [],
    meta: {},
    pagingModel: {
      [deps.config.pageNoKey]: params[deps.config.pageNoKey] || deps.config.defaultPageNo,
      [deps.config.pageSizeKey]: params[deps.config.pageSizeKey] || deps.config.defaultPageSize[0],
      [deps.config.sortColumnKey]: params[deps.config.sortColumnKey] || deps.config.defaultSortColumnKey,
      [deps.config.directionKey]: params[deps.config.directionKey] === undefined ? deps.config.defaultSortDirection : params[deps.config.directionKey],
      [deps.config.filtersKey]: {},
    },
  };
}

function fetchData(fetchFunction, gridId, model) {
  const gridModel = _.get(model, gridId);
  return fetchFunction(model, gridModel.pagingModel).then((result) => {
    const newGridModel = _.merge(gridModel, {
      meta: evalMeta(result),
      loaded: true,
    });
    newGridModel.data = result.content || result;
    return _.set(model, gridId, newGridModel);
  });
}

function gotoPage(deps, gridId, model, page) {
  return _.get(model, gridId).fetchData(
    _.set(
      model,
      `${gridId}.pagingModel.${deps.config.pageNoKey}`,
      Number.isNaN(page) ? 0 : page
    )
  );
}

function nextPage(gotoPageFunc, deps, gridId, model) {
  let pageNo = _.get(model, `${gridId}.pagingModel.${deps.config.pageNoKey}`);
  return gotoPageFunc(model, ++pageNo);
}

function prevPage(gotoPageFunc, deps, gridId, model) {
  let pageNo = _.get(model, `${gridId}.pagingModel.${deps.config.pageNoKey}`);
  return gotoPageFunc(model, --pageNo);
}

function setFilters(deps, gridId, model, filters) {
  return _.set(model, `${gridId}.pagingModel.${deps.config.filtersKey}`, filters);
}

function applyFilters(deps, gridId, model, filters) {
  return _.get(model, gridId).fetchData(
    _.set(
      _.set(model, `${gridId}.pagingModel.${deps.config.pageNoKey}`, 0),
      `${gridId}.pagingModel.${deps.config.filtersKey}`,
      removeEmptyFilters(filters)
    )
  );
}

function removeEmptyFilters(filters = []) {
  return Object.keys(filters).reduce((newFilters, key) => {
    const value = filters[key];
    if (value) {
      newFilters[key] = value;
    }
    return newFilters;
  }, {});
}

function sortByColumn(deps, gridId, model, column, direction) {
  return _.get(model, gridId).fetchData(
    _.flow([
      obj => _.set(obj, `${gridId}.pagingModel.${deps.config.sortColumnKey}`, column),
      obj => _.set(obj, `${gridId}.pagingModel.${deps.config.directionKey}`, direction.toString())
    ])(model)
  );
}

function changePageSize(deps, gridId, model, pageSize) {
  return _.get(model, gridId).fetchData(_.set(model, `${gridId}.pagingModel.${deps.config.pageSizeKey}`, pageSize));
}

function sortItems(items, column, direction) {
  return _.orderBy(items, [column], [direction]);
}

function filterItems(items, filters = {}, customHandlers = {}) {
  const filterKeys = Object.keys(filters).filter((item) => filters[item] !== undefined && filters[item] !== null);
  return _.cloneDeep(items).filter((item) => filterKeys.every((key) => (customHandlers[key] || defaultFilterHandler)(item, filters, key)));
}

function evalMeta(result) {
  return {
    count: result.totalElements,
    pagesCount: result.totalPages,
    page: result.number,
    displayedPage: ++result.number,
    pageSize: result.size,
    hasPreviousPage: result.hasPrevious,
    hasNextPage: result.hasNext,
  };
}

export default {
  applyGrid,
  sortItems,
  filterItems,
  setFilters,
  defaultFilterHandler,
  ASC_DESC_MAPPING,
};



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-grid/grid.js